export default "__VITE_ASSET__568541e5__"